<template>
  <tabs parent="sim_task_list">
    <tab
        id="task_list"
        :name="translate('sim_task_list.task_list.title')"
        :href="url+'/task_list'"
    >
      <TaskList />
    </tab>

    <tab
        id="task_types"
        :name="translate('sim_task_list.task_types.title')"
        :href="url+'/task_types'"
    >
      <TaskTypes />
    </tab>

    <tab
        id="action_list"
        :name="translate('sim_task_list.action_list.title')"
        :href="url+'/action_list'"
    >
      <ActionList />
    </tab>
  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import TaskList from "./Tabs/TaskList/TaskList.vue"
import ActionList from "./Tabs/ActionList/ActionList.vue";
import TaskTypes from "./Tabs/TaskTypes/TaskTypes.vue";

export default {
  name: 'SimTaskList',
  components:{
    Tab,
    Tabs,
    TaskList,
    TaskTypes,
    ActionList
  },
  data () {
    return {

    }
  },

  computed: {
    url () { return '/sim_task_list' }
  },

  created () {

  },

  methods: {

  },
}
</script>
